module.exports = __webpack_public_path__ + "img/1122646755.56be3752.png";